module.exports = __webpack_public_path__ + "img/search_null.85ea217c.png";